
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { useEmployees } from "@/hooks/useEmployees";
import { statusLabels, priorityLabels } from "./TaskBadges";
import { Task } from "@/types/task";

interface TasksFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  statusFilter: string;
  onStatusChange: (value: string) => void;
  priorityFilter: string;
  onPriorityChange: (value: string) => void;
  assignedToFilter: string;
  onAssignedToChange: (value: string) => void;
  onClearFilters: () => void;
}

export function TasksFilters({
  searchTerm,
  onSearchChange,
  statusFilter,
  onStatusChange,
  priorityFilter,
  onPriorityChange,
  assignedToFilter,
  onAssignedToChange,
  onClearFilters,
}: TasksFiltersProps) {
  const { employees } = useEmployees();

  return (
    <div className="p-4 bg-gray-50 rounded-lg border">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        <Input
          placeholder="ابحث عن مهمة..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="lg:col-span-2"
        />
        <Select value={statusFilter} onValueChange={onStatusChange}>
          <SelectTrigger>
            <SelectValue placeholder="تصفية حسب الحالة" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">كل الحالات</SelectItem>
            {Object.entries(statusLabels).map(([value, label]) => (
              <SelectItem key={value} value={value}>{label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Select value={priorityFilter} onValueChange={onPriorityChange}>
          <SelectTrigger>
            <SelectValue placeholder="تصفية حسب الأولوية" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">كل الأولويات</SelectItem>
             {Object.entries(priorityLabels).map(([value, label]) => (
              <SelectItem key={value} value={value}>{label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Select value={assignedToFilter} onValueChange={onAssignedToChange}>
          <SelectTrigger>
            <SelectValue placeholder="تصفية حسب الموظف" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">كل الموظفين</SelectItem>
            {employees.map((employee) => (
              <SelectItem key={employee.id} value={employee.id}>{employee.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="mt-4">
        <Button variant="ghost" onClick={onClearFilters}>
          إلغاء الفلاتر
        </Button>
      </div>
    </div>
  );
}
